import React from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import { Row, Skeleton } from "antd";
import LinearDivider from "../../../components/LinearDividers";
import { detectIos } from "../../../constant/helper";

function Information({
  informations,
  origin,
  destination,
  pinData,
  loading = false,
  title = "",
}) {
  const generateNavigationRoute = () => {
    return detectIos()
      ? `https://maps.apple.com/maps?daddr=${pinData.lat},${pinData.lng}&t=h&q=${title}&dirflg=d`
      : `https://www.google.com/maps/dir/?api=1&travelmode=driving&layer=traffic&destination=${pinData.lat},${pinData.lng}`;
  };

  return (
    <div className="information">
      <Skeleton title loading={loading}>
        <>
          <div className="marker-info-title">{title}</div>
          <LinearDivider width={"50%"} />
          <Row className="address-wrapper">
            <div className="address">{informations.address || "نامشخص"}</div>
            <span className="icon-lbs-2" />
          </Row>
          <Row className="work-hour-navigation">
            <div className="start-navigation">
              <div className="text">
                <a
                  href={generateNavigationRoute()}
                  // href={`https://www.google.com/maps/dir/Current+Location/${location}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  مسیریابی
                </a>
              </div>
              <span className="icon-lbs-11" />
            </div>
            {/* <div className="arrive-time">
              <div className="time">13 دقیقه</div>
              <span className="icon-lbs-1" />
            </div> */}
            <div className="work-hour">
              <div className="title">
                {informations.working_time || "نامشخص"}
              </div>
              <span className="icon-lbs-8" />
            </div>
          </Row>
          <LinearDivider width={"80%"} />
          <Row className="contact">
            <div className="phone">
              <div className="text">
                {informations.phone ? (
                  <a href={`tel:${informations.phone}`}>{informations.phone}</a>
                ) : (
                  "نامشخص"
                )}
              </div>
              <span className="icon-lbs-3" />
            </div>
          </Row>
          <Row className="contact">
            <div className="website">
              <div className="text">
                {informations.website ? (
                  <a
                    href={informations.website}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {informations.website}
                  </a>
                ) : (
                  "نامشخص"
                )}
              </div>
              <span className="icon-lbs-4" />
            </div>
          </Row>
          <LinearDivider width={"120%"} />
          <div className="contact-lawyer-wrapper">
            <NavLink to={"/home"} className="contact-lawyer">
              <div className="text"> مشاوره با وکیل</div>
              <span className="icon-logo" />
            </NavLink>
          </div>
        </>
      </Skeleton>
    </div>
  );
}

Information.propTypes = {
  children: PropTypes.element,
};

export default Information;
